import styled from 'styled-components';

export const StyledButton = styled.button`
	p {
		display: flex;
		align-items: center;
	}

	.forward-icon {
		display: flex;
		align-items: center;
		justify-content: center;
	}
`;

export const MoreInformationDialogHeaderStyles = styled.span`
	display: flex;
	align-items: center;
	flex-wrap: wrap;
`;
